























import { Vue, Component } from "vue-property-decorator";
import ContractForm from "@/components/contract/ContractForm.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import LearningGroupForm from "@/components/learning-group/LearningGroupForm.vue";
import { learningGroupsApi } from "@/getinfo-api";
import { LearningGroup as ILearningGroup } from "@/api-v2/learning-group/models";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";

@Component({
  components: { LearningGroupForm, CPage, ContractForm }
})
export default class ContractNew extends Vue {
  group!: ILearningGroup;
  isLoading: boolean = false;

  data() {
    return {
      group: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "learningGroupList" },
        label: this.$tc(this.$translate.TrainingGroups)
      },
      {
        to: { name: "learningGroup", params: { id: this.$route.params.id } },
        label: this.group?.title ?? ""
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  getGroup() {
    learningGroupsApi.Group.getLearningGroup(this.$route.params.id).then(
      res => {
        this.group = res.data;
      }
    );
  }

  editGroup(form: any) {
    this.isLoading = true;
    learningGroupsApi.Group.editLearningGroup(this.$route.params.id, form)
      .then(res => {
        this.$router.push({
          name: "learningGroup",
          params: { id: res.data.id }
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  removeGroup() {
    learningGroupsApi.Group.deleteLearningGroup(this.$route.params.id).then(
      () => {
        this.$router.push({ name: "learningGroupList" });
      }
    );
  }

  cancel() {
    this.$router.push({
      name: "learningGroup",
      params: { id: this.$route.params.id }
    });
  }

  created() {
    this.getGroup();
  }
}
